import no from './@generated/no.json';
import { Translations } from './@generated/Translations';

interface Language {
  translations: Translations;
}

const availableLanguages: Record<string, Language> = {
  no: {
    translations: no,
  },
};

const initialLanguage: Language = availableLanguages.no;

let i18n: Translations = initialLanguage.translations;

const setLanguage = (languageCode: string): void => {
  if (availableLanguages.hasOwnProperty(languageCode)) {
    i18n = availableLanguages[languageCode].translations;
  } else {
    throw new Error(`Invalid language code ${languageCode}`);
  }
};

export { i18n, setLanguage };
